import {
  PHONE_PAGE_SIZE,
  PHONE_PAGE_SIZES,
  listWindowToParams,
  readListWindow,
} from "./list-window";

export { PHONE_PAGE_SIZE, PHONE_PAGE_SIZES };

export type PhoneListParams = {
  q: string;
  page: number;
  pageSize: number;
};

export function phoneListFromParams(params: URLSearchParams): PhoneListParams {
  return {
    q: params.get("q") || "",
    ...readListWindow(params, PHONE_PAGE_SIZES, PHONE_PAGE_SIZE),
  };
}

export function phoneListToParams(
  list: PhoneListParams
): Record<string, string | undefined> {
  const q = list.q.trim();
  return {
    q: q || undefined,
    ...listWindowToParams(list, PHONE_PAGE_SIZE),
  };
}
